/**
 * @param {string} url
 * @returns {Object}
 */
 export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * 分片滚动
 * @param {*} array 被分片数组
 * @param {*} pageSize 每页数量
 * @param {*} step 每页间隔数
 * @returns
 */
export function slicingArray(array, pageSize = 1, step = 1, isFullPage = true) {
  if (step > pageSize) {
    console.error('间隔不可大于每页数量')
    return
  }

  let total = array.length
  let pageList = []

  for (let i = 0; i < total; i += step) {
    let page = []

    let start = i
    let end = i + pageSize
    if (isFullPage && i + pageSize > total) {
      end = total
      start = total - pageSize
    }
    if (start < 0) {
      start = 0
    }
    for (let j = start; j < end; j ++) {
      if (j >= total) {
        break
      }
      page.push(array[j])
    }
    pageList.push(page)

    if ((page.length < pageSize) || (end == total)) {
      break;
    }
  }

  return pageList
}



export function numberFormat(num) {
  return num >= 10 ? num : '0' + num
}



// 该函数主要功能返回，滚动的高度以及文档占比窗口高度的百分比
export function scrollTop(callback){
  // 页面总高
  var totalH = document.body.scrollHeight || document.documentElement.scrollHeight;
  // 可视高
  var clientH = window.innerHeight || document.documentElement.clientHeight;
  var result = {}
  window.addEventListener('scroll', function(e){
    // 计算有效高
    var validH = totalH - clientH
    // 滚动条卷去高度
    var scrollH = document.body.scrollTop || document.documentElement.scrollTop
    // 百分比
    result.percentage = (scrollH/validH*100).toFixed(2)
    result.scrollH = scrollH;
    callback && callback(result)
  })
}

//识别是移动设备
export function isMobile(){
	if( navigator.userAgent.match(/Android/i)
		|| navigator.userAgent.match(/webOS/i)
		|| navigator.userAgent.match(/iPhone/i)
		|| navigator.userAgent.match(/iPad/i)
		|| navigator.userAgent.match(/iPod/i)
		|| navigator.userAgent.match(/BlackBerry/i)
		|| navigator.userAgent.match(/Windows Phone/i)
	)return true;
	return false;
}



// WEBPACK FOOTER //
// ./src/utils/index.js